import React, { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Typography, TextField, Box, IconButton } from '@mui/material';
import { Edit as EditIcon } from '@mui/icons-material';
import api from '@utils/axiosInstance';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { setVodInfo } from '@modules/media';

function VideoDescription() {
    const { uuid } = useParams();
    const dispatch = useDispatch();
    const vodInfo = useSelector((state: any) => state.media.vodInfo);
    const userToken = useSelector((state: any) => state.organization.userToken);
    const organizationData = useSelector((state: any) => state.organization.organizationData);

    const [isEditing, setIsEditing] = useState(false);
    const [description, setDescription] = useState('');
    const [originalDescription, setOriginalDescription] = useState('');
    const textFieldRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (vodInfo && vodInfo.desc) {
            setDescription(vodInfo.desc);
            setOriginalDescription(vodInfo.desc);
        }
    }, [vodInfo]);

    const handleClick = () => {
        setIsEditing(true);
        if (textFieldRef.current) {
            textFieldRef.current.focus();
        }
    };

    const handleBlur = async () => {
        if (description !== originalDescription) {
            const toastId = toast.info('설명을 수정 중입니다...', {
                position: 'top-center',
                autoClose: false
            });

            try {
                const response = await api({
                    method: 'post',
                    url: '/csmsmedia/video/setDesc',
                    data: {
                        uuid,
                        desc: description
                    }
                });

                if (response.data.code === 100) {
                    console.log('aa', response.data);
                    setOriginalDescription(description);
                    setDescription(description);

                    // VOD 정보 갱신
                    api({
                        method: 'post',
                        url: '/csmsmedia/video/getVideoInfo',
                        data: {
                            uuid
                        }
                    })
                        .then((response) => {
                            if (response.data.code === 100) {
                                dispatch(setVodInfo(response.data.data));
                            }
                        })
                        .catch((error) => {
                            console.error('VOD 정보 갱신 실패:', error);
                            toast.update(toastId, {
                                render: '설명 수정에 실패했습니다.',
                                type: 'error',
                                autoClose: 3000
                            });
                        });

                    toast.update(toastId, {
                        render: '설명이 성공적으로 수정되었습니다.',
                        type: 'success',
                        autoClose: 3000
                    });
                }
            } catch (error) {
                console.error('설명 업데이트 실패:', error);
                setDescription(originalDescription); // 실패 시 원래 값으로 복원
                toast.update(toastId, {
                    render: error.response.data.message,
                    type: 'error',
                    autoClose: 3000
                });
            }
        }
        // 항상 편집 모드 종료
        setIsEditing(false);
    };

    const handleKeyPress = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            textFieldRef.current?.blur();
        }
        if (e.key === 'Escape') {
            setDescription(originalDescription);
            setIsEditing(false);
        }
    };

    return (
        <>
            {isEditing ? (
                <TextField
                    ref={textFieldRef}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    onBlur={handleBlur}
                    onKeyDown={handleKeyPress}
                    variant="outlined"
                    size="small"
                    fullWidth
                    multiline
                    className="video-description__text-field"
                />
            ) : (
                <Box
                    onClick={handleClick}
                    className="video-description__clickable-box"
                >
                    <Typography
                        variant="body2"
                        className="typography__body2-primary video-description__text"
                    >
                        {description || '설명을 입력하세요'}
                    </Typography>
                    <IconButton
                        className="edit-icon"
                        size="small"
                    >
                        <EditIcon fontSize="small" />
                    </IconButton>
                </Box>
            )}
        </>
    );
}

export default VideoDescription;